import { Column } from "@shared/primitive-components"
import { InsightsVehicleData } from "../../../handlers"
import { ChevronFakeLinkCell, VehicleCell, VehicleScoreCell } from "../tableCells"
import { DistanceDrivenHeader, VehicleHeader, VehicleScoreHeader } from "../vehicleTableHeaderCells"

export const generateWorstScoringVehiclesTableColumns = (): ReadonlyArray<Column<InsightsVehicleData>> => [
  {
    Header: VehicleHeader,
    accessor: `vehicle`,
    Cell: VehicleCell,
  },
  {
    Header: VehicleScoreHeader,
    accessor: `vehicleScore`,
    Cell: VehicleScoreCell,
  },
  {
    Header: DistanceDrivenHeader,
    accessor: `currentPeriodDistance`,
  },
  {
    Header: ``,
    accessor: `vrn`,
    Cell: ChevronFakeLinkCell({}),
  },
]
